export class HeaderGapComponent {
  private static headerGapComponentInstance: HeaderGapComponent;

  public static get instance(): HeaderGapComponent {
    if (!HeaderGapComponent.headerGapComponentInstance) {
      HeaderGapComponent.headerGapComponentInstance = new HeaderGapComponent();
    }

    return HeaderGapComponent.headerGapComponentInstance;
  }

  private static initHeaderGapObserver(): void {
    const observer = new MutationObserver(HeaderGapComponent.bodyStyleChangeHandler);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
    });
    HeaderGapComponent.bodyStyleChangeHandler();
  }

  private static bodyStyleChangeHandler(): void {
    document.documentElement.style.setProperty('--drupal-header-height', document.body.style.paddingTop);
  }

  public init(): void {
    window.addEventListener('load', HeaderGapComponent.initHeaderGapObserver);
  }
}
